import { Core } from "@faire/design-tokens";
import privacy from "@faire/web-api--source/routes/www/privacy";
import { LinkFormatting } from "@faire/web/common/localization/formatting";
import { Typography } from "@faire/web/slate/Typography";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import React from "react";

export const CreditHistoryPrivacy: React.FC = () => {
  return (
    <Typography variant="labelSansRegular" color={Core.text.subdued}>
      <StrictLocalMsg
        id="k1tyH8"
        defaultMessage="This info helps us verify your credit history. Learn more about how we use and protect your data at Faire. <LinkFormatting>Privacy at Faire</LinkFormatting>"
        description={{
          text: "Subtitle to introduce business info",
          img: "https://cdn.faire.com/fastly/3734299bdcb8cec265d65f90e42c06f5f52dd7dd7309a8c800735231f91d6b9d.png",
        }}
        values={{
          LinkFormatting: LinkFormatting(privacy(), {
            color: Core.text.subdued,
            target: "_blank",
          }),
        }}
      />
    </Typography>
  );
};
